import {
  SET_LIVE_LINKS,
  SET_LIVE_LINKS_LOADING,
  SET_LIVE_LINKS_ERROR,
} from './action-types';

const initialState = {
  liveLinks: [],
  loading: false,
  error: null,
};

export default function projectLiveLinksDataReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case SET_LIVE_LINKS: {
      return { ...state, liveLinks: action.payload || [] };
    }

    case SET_LIVE_LINKS_LOADING: {
      return { ...state, loading: action.payload };
    }

    case SET_LIVE_LINKS_ERROR: {
      return { ...state, error: action.payload };
    }

    default:
      return state;
  }
}
